const baseFieldClass =
  'w-full rounded-xl border bg-white px-4 py-3 text-[15px] text-smb-ink leading-snug transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-offset-0 border-[#d1d5db] focus:ring-[#224896]/40 focus:border-[#224896] placeholder:text-smb-slate-400';

export const gsgoInputClass = baseFieldClass;

export const gsgoTextareaClass = `${baseFieldClass} min-h-[120px] resize-y`;

export const gsgoLabelClass = 'block text-sm font-semibold text-smb-ink mb-1.5';

export const gsgoSectionEyebrowClass = 'text-xs font-semibold tracking-wide uppercase text-smb-primary-mid';
